import { ref as o, onMounted as t, readonly as n } from "vue";
function u() {
  const e = o(!1);
  return t(() => {
    e.value = !0;
  }), n(e);
}
export {
  u as default
};
